import FantasyLiveMatch from './FantasyLiveMatch';

export default FantasyLiveMatch;
